import axios from 'axios';

import {
  COMPANY_URL,
  WAREHOUSE_BY_COMPANY_URL,
  WAREHOUSES_URL,
} from '../actions/url';
import {
  isGGI, isGFD, isVAK
} from '../actions/root_url';
import { UNAUTH_USER } from '../actions/type';

const COMPANY_FETCH = 'HEADER/COMPANY_FETCH';
const SET_SELECTED_COMPANY = 'HEADER/SET_SELECTED_COMPANY';
const FETCH_WAREHOUSES = 'HEADER/FETCH_WAREHOUSES';
const SET_SELECTED_WAREHOUSE = 'HEADER/SET_SELECTED_WAREHOUSE';


const getDataType = (data) => typeof data;
export const getLocalStorageData = (key) => {
  const value = localStorage.getItem(key);
  if (value === 'undefined' || getDataType(JSON.parse(value)) !== 'object') return isVAK ? '' : {};
  return JSON.parse(value);
}

export const companySelectEpic = action$ =>
  action$.ofType(SET_SELECTED_COMPANY)
    .switchMap(action => {
      let url = `${WAREHOUSE_BY_COMPANY_URL}${action.payload.selectedCompany.value}`;
      // ggi HQ office company id is 3
      if ((isGGI || isGFD) && action.payload.selectedCompany.value && action.payload.selectedCompany.value == 0) {
          return
      }
      return axios.get(
        url,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        }
      )
    })
    .map(response => {
      return ({ type: FETCH_WAREHOUSES, payload: response.data })
    })
    .catch((err, source) => {
      return source;
    });

export const getCompanies = () => dispatch => {
  axios({
    method: 'GET',
    url: COMPANY_URL,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
    .then((res) => {
      dispatch({
        type: COMPANY_FETCH,
        payload: {
          companies: res.data,
        },
      })
    }, (err) => {
      dispatch({
        type: COMPANY_FETCH,
        payload: {
          companies: []
        }
      })
    });
}

export const setSelectedCompany = (selectedCompany) => dispatch => {
  let warehouses = [];
  let selectedWarehouse = {}
  if((isGGI || isGFD) && selectedCompany.value && selectedCompany.value == 0) {
    warehouses.push({ Name:'All', id: '0', IsDefault:true, Company_id_id:0 });
    selectedWarehouse = {label:'All', value: '0'};
  }
  return dispatch({
    type: SET_SELECTED_COMPANY,
    payload: {
      selectedCompany,
      warehouses,
      selectedWarehouse,
    }
  })
}

export const setSelectedWarehouse = selectedWarehouse => dispatch => dispatch({
  type: SET_SELECTED_WAREHOUSE,
  payload: {
    selectedWarehouse,
  }
})

const activeCompany = getLocalStorageData('selectedCompany');
const activeWarehouse =  getLocalStorageData('selectedWarehouse');
// const activeWarehouse = JSON.parse(localStorage.getItem('selectedWarehouse'));
const initialState = {
  companies: [],
  selectedCompany: activeCompany,
  warehouses: [],
  selectedWarehouse: activeWarehouse,
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case COMPANY_FETCH:
      return {
        ...state,
        ...action.payload,
      };
    case SET_SELECTED_COMPANY:
      localStorage.setItem('selectedCompany', JSON.stringify(action.payload.selectedCompany))
      return {
        ...state,
        ...action.payload,
      }
    case FETCH_WAREHOUSES:
      return {
        ...state,
        warehouses: action.payload,
      }
    case SET_SELECTED_WAREHOUSE:
      localStorage.setItem('selectedWarehouse', JSON.stringify(action.payload.selectedWarehouse))
      return {
        ...state,
        ...action.payload,
      }
    case UNAUTH_USER: 
      if(isVAK) {
        return {
          ...state,
          selectedCompany: null,
          selectedWarehouse: null,
          companies: [],
          warehouses: []
        }
      }
      return state
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./master/jsx/reducers/headerRedux.js